import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

export class InactiverPointInscriptionAdministrativeCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private contexteId: string
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .inactiverPointInscriptionAdministrative(this.id, this.contexteId, this.version)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .reactiverPointInscriptionAdministrative(this.id, this.contexteId, this.version)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }
}
